export default __webpack_public_path__ + "static/media/logo-ef-calculator.429e51b7.svg";